// Main login page translations
import registerModule from "./register.js";
import forgotModule from "./forgot.js";
import verifyModule from "./verify.js";
import bindingModule from "./binding.js";
import codegoogleModule from "./codegoogle.js";

// Main login page content
const main = {
  // Page title and welcome information
  title: "User Login",
  welcome: "Welcome to Graphchain System",
  subtitle: "Please enter your account information",

  // Form fields
  username: "Username",
  password: "Password",
  usernamePlaceholder: "Please enter username",
  passwordPlaceholder: "Please enter password",

  // Buttons and links
  login: "Login",
  loginButton: "Login Now",
  forgotPassword: "Forgot password?",
  noAccount: "Don't have an account?",
  register: "Register",
  confirm: "Confirm",
  returnToLogin: "Return to Login",

  // Verification code related
  verificationCode: "Verification Code",
  verificationCodePlaceholder: "Please enter verification code",
  howToViewGoogleAuth: "How to view Google verification code?",
  howToUseGoogleCode: "How to use Google verification code",
  googleAuthBinding: "Google Authenticator Binding",

  // Message prompts
  loginSuccess: "Login successful",
  loginFailed: "Login failed",
  verificationTimeExpired: "Verification time expired, please log in again",
  loading: "Loading...",

  // Form validation
  usernameRequired: "Please enter username",
  passwordRequired: "Please enter password",
  usernameLength: "Username length should be between 2-20 characters",
  passwordLength: "Password length should be between 2-16 characters",
  verificationCodeRequired: "Please enter verification code",
  verificationCodeLength:
    "Verification code length should be between 2-5 characters",

  // Others
  rememberMe: "Remember me",
  switchToRegister: "Don't have an account? Register now",
  welcomeBack: "Welcome back",
  resendCaptcha: "Resend ({time})",
  captchaSentSuccess: "Verification code sent, please check your messages",
  successDialog: {
    defaultTitle: "Operation successful",
    defaultSubtitle: "Add WeChat to request more services",
    defaultConfirm: "OK",
  },
};

export default {
  ...main,
  // Sub-modules
  registerModule,
  forgotModule,
  verifyModule,
  bindingModule,
  codegoogleModule,
};
